<div class='add-button-container'>
    <button class="add-logs-button outlined-button export-logs-button" color="accent" mat-stroked-button (click)="openAddModal()"
    [disabled]="isDisabled">
        + Add Log Event
    </button>
</div>
